if (!customElements.get('ph-scale')) {
  customElements.define('ph-scale', class PhScale extends HTMLElement {
    constructor() {
      super();
      this.indicator = this.querySelector('.ph-scale__indicator');
      
      if (!this.indicator) return;
      
      const phValuesAttr = this.indicator.getAttribute('data-ph-values');
      if (!phValuesAttr) return;
      
      try {
        this.phValues = JSON.parse(phValuesAttr);
      } catch (error) {
        console.error('pH Scale: Error parsing pH values', error);
        return;
      }
      
      this.positionArrow();
      this.onResize = this.debounce(() => this.positionArrow(), 100);
      window.addEventListener('resize', this.onResize);
    }
    
    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
    }
    
    positionArrow() {
      if (!this.phValues || this.phValues.length === 0) return;
      
      let targetPh;
      
      if (this.phValues.length === 1) {
        targetPh = parseFloat(this.phValues[0]);
      } else if (this.phValues.length >= 2) {
        const min = parseFloat(this.phValues[0]);
        const max = parseFloat(this.phValues[1]);
        targetPh = (min + max) / 2;
      }
      
      if (targetPh < 1 || targetPh > 14) return;
      
      // Point to center of cell: ((N - 0.5) / 14) * 100
      const position = ((targetPh - 0.5) / 14) * 100;
      this.indicator.style.left = `${position}%`;
    }
    
    debounce(fn, delay) {
      let timeoutId;
      return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => fn.apply(this, args), delay);
      };
    }
  });
}
